import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { constants, UserRoles } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class ClientAuthRoleGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private cookieService:CookieService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let role = this.cookieService.get('role');
    // MP-5750: CLIENT is admitted here; clientPortalRoleGuard (canActivateChild on the
    // dashboard route) then confines it to the project list and details routes.
    let clientRoleTypes = [constants.userRoles.firmManager,constants.userRoles.projectManager,constants.userRoles.projectOwner,constants.userRoles.client];
    if(this.authService.isAuthenticated() && clientRoleTypes.includes(role)){   
        return true;
    }else{
        this.router.navigateByUrl('/login');
        return false;
    }
     
  }
}
